export default __webpack_public_path__ + "static/Clay1-11a92894e2c7dc3ac6983ad6e81d1a05.png";